<template>
  <div class="Typing">
    <div class="title">髓母细胞瘤分子分型预测</div>
    <div class="show-box"></div>
    <div class="fenzi">
      <h1>分子分型预测结果</h1>
      <p>
        结合受检者的临床信息，将基因检测结果输入髓母细胞瘤分子分型模型进行运算，即可得出四种分子分型（WNT,
        SHH, Group3 和 Group4）的概率值（详见下图），其中
        <span>Group4</span> 型概率值最高，为
        <span>36.9%</span> ，故该受检者的髓母细胞瘤分子分型结果为：<span
          >偏向于Group4 型</span
        >
      </p>
    </div>
    <div class="pie">
      <h1>髓母细胞瘤分子分型概率值分布图</h1>
      <FszPie :data="sexDataPie" height="281px"></FszPie>
    </div>
  </div>
</template>
<script>
import { dataStat } from "@/api/dataStatistics.js";

export default {
  data() {
    return {
      sexDataPie: {
        chartPieData: [
          {
            name: "性别分布",
            color: "#3186FF",
            data: [],
            title: {},
          },
        ],
      },
    };
  },
  mounted(){
      this.getGender()
  },
  methods: {
    async getGender() {
      try {
        let { data } = await dataStat({
          sampleTag: "sex",
        });
        this.sexData = data.sex;
        console.log(this.sexData);
        let sexmap = { 1: "男性", 0: "女性", 2: "未知" };
        let sortmap = { 男性: 0, 女性: 1, 未知: 2 };
        this.sexDataPie.chartPieData[0].data = [
          { value: data.sex[0].sexCount, name: sexmap[data.sex[0].sex] },
          { value: data.sex[1].sexCount, name: sexmap[data.sex[1].sex] },
          { value: data.sex[2].sexCount, name: sexmap[data.sex[2].sex] },
        ].sort((a, b) => {
          return sortmap[a.name] - sortmap[b.name];
        });
        let subtext =
          data.sex[0].sexCount + data.sex[1].sexCount + data.sex[2].sexCount;
        console.log(subtext);

        this.sexDataPie.chartPieData[0].title = {
          text: "样本",
          textStyle: {
            color: "#9095A7",
            fontSize: 12,
            fontWeight: 400,
            padding: [-20, 0, 0, 0],
          },
          subtext: subtext,
          subtextStyle: {
            color: "#2F354D",
            fontSize: 26,
            fontWeight: 600,
          },
          // itemGap: 10, // 主副标题距离

          left: "center",
          top: 90,
        };
      } catch (err) {}
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.Typing {
  background: @background_color;
  font-family: @family;
  border-radius: 10px;
  margin-bottom: 20px;
  .pie {
    padding: 10px 24px;

    h1 {
      font-size: 15PX;
      font-weight: 500;
      color: #2f354d;
      line-height: 22px;
      position: relative;
      padding-left: 12px;
      margin-bottom: 14px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        margin-top: -7px;
        left: 0;
        width: 3px;
        height: 14px;
        background: #2f354d;
        border-radius: 2px;
      }
    }
  }
  .fenzi {
    padding: 10px 24px;
    p {
      font-size: 13px;
      font-weight: 400;
      color: #5f697d;
      line-height: 24px;
      border-bottom: 1px solid #e3e5e8;
      padding-bottom: 20px;
      span {
        color: #27ca8d;
      }
    }
    h1 {
      font-size: 15PX;
      font-weight: 500;
      color: #2f354d;
      line-height: 22px;
      position: relative;
      padding-left: 12px;
      margin-bottom: 14px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        margin-top: -7px;
        left: 0;
        width: 3px;
        height: 14px;
        background: #2f354d;
        border-radius: 2px;
      }
    }
  }
  .title {
    height: 70px;
    line-height: 70px;
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    padding-left: 24px;
  }
}
</style>
